import Icon, { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Collapse as AntdCollapse } from 'antd';
import styled from 'styled-components';

export const Collapse = styled(AntdCollapse).attrs({
  bordered: false,
  accordion: true,
})`
  margin: 18px 0px 18px 0px;
  background: #fffbee;
  border: 1px solid #ebac00;
  border-radius: 4px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

export const IconComp = styled(Icon)``;

export const ArrowDown = styled(DownOutlined)`
  margin-top: 7px;
  font-size: 1rem;
  color: #6d787d;
  border-radius: 1px;
`;

export const ArrowUp = styled(UpOutlined)`
  margin-top: 7px;
  font-size: 1rem;
  color: #6d787d;
  border-radius: 1px;
`;
